<div class="productMeta-img">
    <product-image
        imageClass="img-fluid"
        imageAutomationTag="productImage"
        [images]="images"
        [imageType]="imageType"
        [imageSize]="displaySize"
        [imageOrder]="selectedImageIndex"
        [imageZoom]="true">
    </product-image>
</div>
<div class="productMeta-thumbs" *ngIf="filteredImages?.length > 1">
    <product-image *ngFor="let pImg of filteredImages; let i = index; trackBy: trackByFn"
        [images]="[pImg]"
        imageClass="image-thumbnail"
        [imageType]="imageType"
        [imageSize]="thumbSize"
        [imageOrder]="pImg.imageOrder"
        [imageAutomationTag]="'productThumb' + i"
        [ngClass]="{'selected-img': i===selectedImageIndex}"
        (mouseenter)="changeSelectedIndex(i)"
        [maxImages]="maxImages">
    </product-image>
</div>
